import { Button } from '@codeparva/ui-components-library';
import React from 'react';
import { NavBarTypes } from './navBarTypes';
import { weakKey } from '../../../../utilities/weakKey';
import {
  GenericButtonLinks,
  selectClassName,
} from './helpers/NavBarButtonHelper';

export const NavBarButtonGroup = ({
  buttonsConfig,
  handleNavBarStateButton,
}: NavBarTypes.TButtonGroupType) => {
  let width = window.innerWidth;

  const GetButtonConfig = () => {
    return (
      <>
        {buttonsConfig &&
          buttonsConfig.map((button, index) => (
            <Button
              size="normal"
              className={selectClassName(index, width)}
              key={weakKey(button)}
            >
              <GenericButtonLinks
                handleNavBarStateButton={handleNavBarStateButton}
                width={width}
                button={button}
                index={index}
              />
            </Button>
          ))}
      </>
    );
  };

  return (
    <Button.Group size="small" className="buttonGroup">
      {<GetButtonConfig />}
    </Button.Group>
  );
};
